import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { weeklyCalendar, todayWeekday } from '@/mocks/calendar';

const today = weeklyCalendar.find((day) => day.weekday === todayWeekday) ?? weeklyCalendar[0];

const STEPS = [
  { icon: 'ri-list-ordered', title: '锁定剧集', desc: '先选一部在追的短剧，进入剧集详情页。' },
  { icon: 'ri-sort-asc', title: '核对顺序', desc: '按更新顺序逐集核对集号、日期与集数区间。' },
  { icon: 'ri-book-open-line', title: '补看剧情', desc: '忘了上一集就翻分集介绍，快速接上剧情。' },
  { icon: 'ri-notification-3-line', title: '盯住预告', desc: '下一集预告提前看，更新当天不错过。' },
];

export default function TodayUpdates() {
  return (
    <section id="today" className="w-full scroll-mt-24 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="Daily Update"
          title="今日更新追踪"
          desc="把今天要更新的短剧、集数区间和时间集中放在一起。打开就能对上号，不用一个个平台去翻。"
          actionText="完整追剧日历"
          actionTo="/calendar"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {today.label}更新 · 共 {today.items.length} 部
                </h3>
                <span className="text-xs text-foreground-500">日期：2026-09-10</span>
              </div>

              <ol className="mt-6 space-y-1">
                {today.items.map((item, index) => (
                  <li key={item.dramaId} className="flex gap-4">
                    <div className="flex flex-col items-center">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xs text-background-50">
                        <i className="ri-check-line" aria-hidden="true" />
                      </span>
                      {index < today.items.length - 1 && (
                        <span className="my-1 w-px flex-1 bg-background-300" aria-hidden="true" />
                      )}
                    </div>
                    <div className="flex-1 pb-6">
                      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                        <span className="font-display text-sm text-accent-700">{item.time}</span>
                        <Link
                          to={`/drama/${item.dramaId}`}
                          className="cursor-pointer text-sm font-medium text-foreground-950 transition-colors hover:text-primary-600"
                        >
                          《{item.dramaTitle}》
                        </Link>
                        <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                          {item.range}
                        </span>
                      </div>
                      <p className="mt-2 text-xs leading-6 text-foreground-500">
                        按更新顺序已排入追踪表，点击剧名可查看该剧分集剧情介绍与下一集预告。
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-foreground-950">怎么用它追剧不漏更</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-600">
                四个动作养成习惯，顺序清楚、剧情不串、预告不落。
              </p>
              <ul className="mt-6 space-y-4">
                {STEPS.map((step, index) => (
                  <li key={step.title} className="flex gap-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50 text-primary-600">
                      <i className={`${step.icon} text-lg`} aria-hidden="true" />
                    </span>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">
                        <span className="font-display mr-2 text-accent-600">0{index + 1}</span>
                        {step.title}
                      </p>
                      <p className="mt-1 text-xs leading-6 text-foreground-500">{step.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}